export default __webpack_public_path__ + "static/media/vehicle-tracking.a08c0f67.jpg";